import React, { useEffect } from "react";
import { Button } from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import SyncIcon from "@mui/icons-material/Sync";
import Search from "./Search";
import excelIcon from "../../assets/images/png/reportExcel.png";
import "./Header.css";
import { Dayjs } from "dayjs";
import { StatusFilterMenuItems } from "../../types/types";
import StatusFilter from "../../features/deliveryConfirmation/StatusFilter";
import RealTimeStockStatusFilter from "../../features/stocks/RealTimeStock/RealTimeStockStatusFilter";

interface HeaderProps<T> {
  title: string;
  searchFunction?: (value: string) => void;
  onRefresh?: () => void;
  handleCreateBtnClick?: () => void;
  createBtnLabel?: string;
  downloadReportIcon?: boolean;
  downloadReportOnClick?:()=>void;
  buttonRef?: React.RefObject<HTMLButtonElement>;
  lastRefreshed?:Dayjs;
  resetSearch?: boolean;
  showDistributorFilter?: boolean;
  onDistributorChange?: (distributorId: string) => void;
  distributorList?: StatusFilterMenuItems[];
  enableTruncation?: boolean;
  Component?: React.ReactNode; 
  createBtnDisabled?: boolean
}

const Header = <T extends Record<string, any>>({
  title,
  searchFunction,
  onRefresh,
  handleCreateBtnClick,
  createBtnLabel = "",
  downloadReportIcon = false,
  downloadReportOnClick,
  buttonRef,
  lastRefreshed,
  resetSearch = false,
  showDistributorFilter = false,
  onDistributorChange,
  distributorList = [],
  enableTruncation = false,
  Component,
  createBtnDisabled
}: HeaderProps<T>) => {

useEffect(() => {
  const handleKeyDown = (event: KeyboardEvent) => {
    if (event.shiftKey && event.key === 'N') {
      event.preventDefault();
      const activeElement = document.activeElement;
      const isInputField =
        activeElement?.tagName === 'INPUT' ||
        activeElement?.tagName === 'TEXTAREA' ||
        activeElement?.tagName === 'SELECT';

      if (!isInputField && handleCreateBtnClick) {
        handleCreateBtnClick();
      }
    }
  };

  window.addEventListener('keydown', handleKeyDown);
  return () => {
    window.removeEventListener('keydown', handleKeyDown);
  };
}, [handleCreateBtnClick, title, createBtnLabel, searchFunction, showDistributorFilter]);


  return (
    <div className="Header">
      <div className="Header_label">
        <div className="Header_label_bar" />
        {title}
        {lastRefreshed && (
          <span className="Header_lastRefreshed" style={{ display: 'inline-flex', alignItems: 'center' , gap: "12px"}}>
            Last updated on: {lastRefreshed.format("YYYY-MM-DD HH:mm:ss")}
            {onRefresh && lastRefreshed && (
              <SyncIcon
                className="Header_refresh"
                sx={{ fill: "#1C7EA0 !important" }}
                onClick={onRefresh}
              />
            )}

          </span>
        )}
      

      </div>
      <div
        className={`Header_tools_container ${handleCreateBtnClick ? "" : "searchJustifyEnd"}`}
      >
        {showDistributorFilter && distributorList.length > 0 && onDistributorChange && (
          <div className="Header_distributor_filter" style={{ marginRight: '15px' }}>
            <RealTimeStockStatusFilter
              onStatusChange={onDistributorChange}
              statusFilterMenuItems={distributorList}
              enableTruncation={enableTruncation}
            />
          </div>
        )}
        
        {onRefresh && !lastRefreshed &&(
          <SyncIcon
            className="Header_refresh"
            sx={{ fill: "#1C7EA0 !important" }}
            onClick={onRefresh}
          />
        )}
        {Component && (
          <div className="form-header-filter">
            {Component}
          </div>
        )}
        {searchFunction && (
          <div className={`${handleCreateBtnClick ? "" : "searchWidth"}`}>
            <Search searchFunction={searchFunction} resetSearch={resetSearch} />
          </div>
        )}
        {handleCreateBtnClick && (
          <Button
            ref={buttonRef}
            variant="contained"
            sx={{
              backgroundColor: "#237C9D",
              padding: "0.5rem 0.5rem",
              fontSize: "0.6rem",
              minWidth: "11rem",
              height: "40px",
              boxShadow:'none'
              
            }}
            onClick={handleCreateBtnClick}
            disabled={createBtnDisabled}
          >
            <AddCircleIcon sx={{ fontSize: "18px", marginRight: "5px" }} />{" "}
            <span className="Header_createBtn_text">{createBtnLabel}</span>
            &nbsp;<span style={{fontSize:"9.5px", textTransform:"none"}}>(Shift + N)</span>
          </Button>
        )}
        {downloadReportIcon && (
          <img src={excelIcon} alt="Report" className="excelIcon" onClick={downloadReportOnClick}/>
        )}
      </div>
    </div>
  );
};

export default Header;
